import { Box } from '@mui/material';
import { LwButton } from 'redesign';
import { useTranslation } from 'react-i18next';
import { WorkflowCanvas } from './workflow-canvas/workflow-canvas';
import { useSidebarControl } from './hooks/use-sidebar-control/use-sidebar-control';
import { WorkflowSidebar } from './workflow-sidebar/workflow-sidebar';
import type { WorkflowGraphControl } from './hooks/use-workflow-graph';

type WorkflowEditorProps = {
  graphControl: WorkflowGraphControl;
  addNodeDisabled?: boolean;
};

export const WorkflowEditor = ({ graphControl, addNodeDisabled = false }: WorkflowEditorProps) => {
  const sidebarControl = useSidebarControl(graphControl);
  const { t } = useTranslation(['ogp-screen-specific']);
  const isAddNodeEnabled = graphControl.isGraphValidForCreate();

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column" position="relative">
      <Box position="absolute" top={8} right={8} zIndex={1}>
        <LwButton
          iconColorMode="fill"
          onClick={sidebarControl.openNodeLibrary}
          data-testid="add-node-button"
          disabled={addNodeDisabled || !isAddNodeEnabled}
        >
          {t('workflows.addNode', { defaultValue: 'Add node' })}
        </LwButton>
      </Box>
      <WorkflowCanvas graphControl={graphControl} onNodeDoubleClick={sidebarControl.openEdit} />
      <WorkflowSidebar controller={sidebarControl} />
    </Box>
  );
};
